module.exports = __webpack_public_path__ + "static/media/villa-terracota-cabana-360-preview.1bd58a94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/villa-terracota-cabana-360-preview.jpg
// module id = 1159
// module chunks = 0